import { Leg } from 'common/utils';
import { RoutePoint } from 'common/utils/directionsService/types';

import { intl } from 'i18n/Translations';

const getLegName = (index: number): string => (
  index === 0 ? 'startPoint' : `waypoint${index}`
);

export const mappingHereRouteLegs = (
  sections: any[],
  allWaypoints: RoutePoint[]
) => sections
  .reduce((acc: Leg[], item, index) => {
    const {
      departure: {
        place: {
          location: departureLocation
        }
      },
      arrival: {
        place: {
          location: arrivalLocation
        }
      },
      travelSummary: {
        length
      }
    } = item;
    const { value: address = '' } = allWaypoints[index] || {};

    acc.push({
      address,
      location: departureLocation,
      distance: `${length / 1000} ${intl.formatMessage({ id: 'km' })}`,
      name: getLegName(index)
    });

    if (index === sections.length - 1) {
      const { value: endAddress = '' } = allWaypoints[index + 1] || {};
      acc.push({
        address: endAddress,
        location: arrivalLocation,
        distance: '',
        name: 'endPoint'
      });
    }

    return acc;
  }, [] as Leg[]);
